const getV4GraphicsSiteApiCall = (siteId, headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/getV4GraphicsSite?siteId=${siteId}`,
      {
        method: "GET",
        headers: headersConfigData()
      }
    )
  } else {
    return { msg: "All Parameters are required" };
  }
}

const setV3GraphicsSiteApiCall = (siteId, request, headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/SaveV3GraphicsSite?siteId=${siteId}`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(request),
      }
    )
  } else {
    return { msg: "All Parameters are required" };
  }
}

export const API_CALLS = {
  getV4GraphicsSiteApiCall,
  setV3GraphicsSiteApiCall
};
